import {
    Dashboard as DashboardIcon,
    Restaurant as RestaurantIcon,
    Category as CategoryIcon,
    Inventory as InventoryIcon,
    ShoppingCart as OrderIcon,
    QrCode2 as QrCodeIcon,
    LocalOffer as OfferIcon,
    People as PeopleIcon,
    Payment as PaymentIcon,
    Star as RatingIcon,
    Kitchen as KitchenIcon,
    Store as StoreIcon,
    Receipt as ReceiptIcon,
    Settings as SettingsIcon,
    Person as PersonIcon,
    AttachMoney as MoneyIcon,
    LocationOn as LocationIcon,
    TableRestaurant as TableIcon,
    Loyalty as LoyaltyIcon,
    LocalShipping as DeliveryIcon,
    Hotel as HotelIcon,
} from '@mui/icons-material';

// Modern modular navigation structure
export const modernNavigationModules = [
    {
        id: 'overview',
        title: 'Overview',
        description: 'Dashboard & Analytics',
        color: '#6366f1',
        icon: <DashboardIcon />,
        items: [
            {
                title: 'Dashboard',
                path: '/dashboard',
                icon: <DashboardIcon />,
                description: 'Analytics & KPIs',
            },
        ],
    },
    {
        id: 'menu-management',
        title: 'Menu Management',
        description: 'Complete menu setup and configuration',
        color: '#10b981',
        icon: <RestaurantIcon />,
        items: [
            {
                title: 'Unified Menu Setup',
                path: '/unified-menu-setup',
                icon: <RestaurantIcon />,
                description: 'All-in-one menu management',
                badge: 'New',
            },
            {
                title: 'Categories',
                path: '/menu/categories',
                icon: <CategoryIcon />,
                description: 'Manage menu categories',
            },
            {
                title: 'Sub Categories',
                path: '/menu/subcategories',
                icon: <CategoryIcon />,
                description: 'Organize subcategories',
            },
            {
                title: 'Menu Items',
                path: '/menu/items',
                icon: <RestaurantIcon />,
                description: 'Add and edit menu items',
            },
            {
                title: 'Variations',
                path: '/menu/variations',
                icon: <InventoryIcon />,
                description: 'Item size & variations',
            },
            {
                title: 'Modifiers',
                path: '/menu/modifiers',
                icon: <SettingsIcon />,
                description: 'Add-ons & customizations',
            },
        ],
    },
    {
        id: 'ordering',
        title: 'Order Management',
        description: 'Orders, QR codes, and order tracking',
        color: '#f59e0b',
        icon: <OrderIcon />,
        items: [
            {
                title: 'All Orders',
                path: '/orders',
                icon: <OrderIcon />,
                description: 'View all orders',
            },
            {
                title: 'Order Status',
                path: '/orders/status',
                icon: <ReceiptIcon />,
                description: 'Track order status',
            },
            {
                title: 'QR Code Tables',
                path: '/qr-tables',
                icon: <QrCodeIcon />,
                description: 'QR table ordering',
            },
            {
                title: 'Dine-In Orders',
                path: '/orders/dine-in',
                icon: <TableIcon />,
                description: 'Restaurant orders',
            },
            {
                title: 'Takeaway',
                path: '/orders/takeaway',
                icon: <OrderIcon />,
                description: 'Pickup orders',
            },
            {
                title: 'Delivery',
                path: '/orders/delivery',
                icon: <DeliveryIcon />,
                description: 'Delivery management',
            },
            {
                title: 'Guest Hub Board',
                path: '/guest-hub-admin',
                icon: <HotelIcon />,
                description: 'Rooms & guest requests',
                badge: 'New',
            },
        ],
    },
    {
        id: 'promotions',
        title: 'Promotions & Offers',
        description: 'Discounts, offers, and loyalty programs',
        color: '#ec4899',
        icon: <OfferIcon />,
        items: [
            {
                title: 'Discounts',
                path: '/promotions/discounts',
                icon: <OfferIcon />,
                description: 'Manage discounts',
            },
            {
                title: 'Offers',
                path: '/promotions/offers',
                icon: <OfferIcon />,
                description: 'Special offers',
            },
            {
                title: 'Loyalty Program',
                path: '/loyalty',
                icon: <LoyaltyIcon />,
                description: 'Points & rewards',
            },
        ],
    },
    {
        id: 'customers',
        title: 'Customer Management',
        description: 'Customer profiles and engagement',
        color: '#8b5cf6',
        icon: <PeopleIcon />,
        items: [
            {
                title: 'Customers',
                path: '/customers',
                icon: <PeopleIcon />,
                description: 'Customer database',
            },
            {
                title: 'Customer Profiles',
                path: '/customers/profiles',
                icon: <PersonIcon />,
                description: 'Detailed profiles',
            },
            {
                title: 'Ratings & Reviews',
                path: '/reviews',
                icon: <RatingIcon />,
                description: 'Customer feedback',
            },
        ],
    },
    {
        id: 'payments',
        title: 'Payments & Finance',
        description: 'Transactions and financial tracking',
        color: '#06b6d4',
        icon: <PaymentIcon />,
        items: [
            {
                title: 'Payments',
                path: '/payments',
                icon: <PaymentIcon />,
                description: 'Payment processing',
            },
            {
                title: 'Transactions',
                path: '/transactions',
                icon: <ReceiptIcon />,
                description: 'Transaction history',
            },
            {
                title: 'Financial Reports',
                path: '/finance/reports',
                icon: <MoneyIcon />,
                description: 'Financial analytics',
            },
        ],
    },
    {
        id: 'kitchen',
        title: 'Kitchen Operations',
        description: 'Kitchen management and order routing',
        color: '#f97316',
        icon: <KitchenIcon />,
        items: [
            {
                title: 'Kitchen Display',
                path: '/kitchen',
                icon: <KitchenIcon />,
                description: 'Kitchen orders',
            },
            {
                title: 'Order Routing',
                path: '/kitchen/routing',
                icon: <DeliveryIcon />,
                description: 'Route orders',
            },
        ],
    },
    {
        id: 'inventory',
        title: 'Inventory Management',
        description: 'Stock tracking and supplier management',
        color: '#14b8a6',
        icon: <InventoryIcon />,
        items: [
            {
                title: 'Menu Inventory',
                path: '/inventory/menu',
                icon: <InventoryIcon />,
                description: 'Menu stock levels',
            },
            {
                title: 'Raw Materials',
                path: '/inventory/raw-materials',
                icon: <StoreIcon />,
                description: 'Raw material stock',
            },
            {
                title: 'Batches & Expiry',
                path: '/inventory/batches',
                icon: <ReceiptIcon />,
                description: 'Track batches',
            },
            {
                title: 'Suppliers',
                path: '/suppliers',
                icon: <DeliveryIcon />,
                description: 'Supplier management',
            },
            {
                title: 'Purchase Orders',
                path: '/purchases',
                icon: <OrderIcon />,
                description: 'GRN & purchases',
            },
            {
                title: 'Stock Adjustments',
                path: '/inventory/adjustments',
                icon: <SettingsIcon />,
                description: 'Adjust stock',
            },
        ],
    },
    {
        id: 'operations',
        title: 'Operations & Setup',
        description: 'Locations, employees, and configuration',
        color: '#64748b',
        icon: <SettingsIcon />,
        items: [
            {
                title: 'Locations & Branches',
                path: '/locations',
                icon: <LocationIcon />,
                description: 'Manage locations',
            },
            {
                title: 'Tables',
                path: '/tables',
                icon: <TableIcon />,
                description: 'Table management',
            },
            {
                title: 'Employees',
                path: '/employees',
                icon: <PersonIcon />,
                description: 'Staff management',
            },
            {
                title: 'Settings',
                path: '/settings',
                icon: <SettingsIcon />,
                description: 'System configuration',
            },
        ],
    },
];

// Legacy navigation items (kept for compatibility)
export const navigationItems = [
    {
        title: 'Dashboard',
        path: '/dashboard',
        icon: <DashboardIcon />,
        roles: ['admin', 'manager', 'staff'],
    },
    {
        title: 'Settings',
        path: '/settings',
        icon: <SettingsIcon />,
        roles: ['admin', 'manager'],
    },
];

// Quick access shortcuts for command palette
export const quickAccessItems = modernNavigationModules.flatMap((module) =>
    module.items.map((item) => ({
        ...item,
        module: module.title,
        moduleColor: module.color,
    }))
);
